import { ProgressBar } from 'primereact/progressbar';

const Loading = () => (<ProgressBar mode="indeterminate" />)

export default Loading